export const eventMessages = {
  "cs": {
    "events.backToEvents": "Události",
    "events.registrationIntro": "Zkontrolujte vybraný termín a doplňte své kontaktní údaje.",
    "tickets.registrationIntro": "Zkontrolujte vybraný termín, vyberte počet míst a doplňte údaje kupujícího.",
    "events.summary": "Vybraná událost",
    "events.date": "Termín",
    "events.location": "Místo",
    "events.organizer": "Pořadatel",
    "events.occupancy": "Obsazenost",
    "events.contactHeading": "Kontaktní údaje",
    "events.unavailableTitle": "Událost není dostupná",
    "events.unavailableDescription": "Tato událost nebo termín už nejsou v nabídce portálu. Vyberte si jinou událost.",
    "events.cancelled": "Termín byl zrušen",
    "events.closedDescription": "Vyberte si jiný termín v přehledu událostí.",
    "events.signInHint": "Pro přihlášení na tuto událost se přihlaste do svého účtu.",
    "events.accessHint": "Na tuto událost se nyní nemůžete přihlásit.",
    "events.addTicket": "Přidat místo",
    "events.removeTicket": "Odebrat místo",
    "events.title": "Události",
    "events.unlimited": "Bez omezení kapacity",
    "events.capacity": "Obsazenost: {occupied}/{capacity}",
    "events.registered": "Jste přihlášeni",
    "events.started": "Již začalo",
    "events.full": "Obsazeno",
    "events.register": "Registrovat se na událost",
    "events.noAccountRequired": "Účet ani přihlášení nejsou potřeba.",
    "events.login": "Přihlásit se do portálu",
    "events.unavailable": "Registrace není dostupná",
    "events.registration": "Registrace na událost",
    "events.name": "Jméno",
    "events.email": "E-mail",
    "events.phone": "Telefon (nepovinné)",
    "events.places": "Počet míst",
    "events.immediate": "Přihlášení je potvrzené ihned, bez čekání na schválení.",
    "events.cancel": "Zpět",
    "events.saving": "Přihlašování…",
    "events.confirm": "Potvrdit přihlášení",
    "events.success": "Vaše přihlášení je potvrzené.",
    "events.error": "Přihlášení se nezdařilo. Zkontrolujte dostupnost míst a zadané údaje.",
    "events.rateLimit": "Příliš mnoho pokusů. Zkuste to za chvíli.",
    "events.andTickets": "Události a vstupenky",
    "registrations.title": "Moje rezervace a vstupenky",
    "registrations.description": "Vaše nadcházející rezervace a potvrzené vstupenky.",
    "registrations.upcomingBookings": "Nadcházející rezervace a vstupenky",
    "registrations.searchBookings": "Hledat v rezervacích a vstupenkách",
    "registrations.noMatchingBookings": "Nebyly nalezeny žádné rezervace ani vstupenky.",
    "registrations.allBookings": "Všechny rezervace a vstupenky",
    "schedule.emptyTitle": "Zatím žádné termíny",
    "schedule.emptyDescription": "Tady najdete své rezervace, události a vstupenky.",
    "schedule.status.confirmed": "Potvrzeno",
    "schedule.status.completed": "Dokončeno",
    "schedule.status.pending": "Čeká na potvrzení",
    "schedule.status.cancelled": "Zrušeno",
    "schedule.status.no_show": "Nedostavil/a se",
    "schedule.status.unknown": "Stav není uveden",
    "tickets.title": "Vstupenky",
    "tickets.mine": "Moje vstupenky",
    "tickets.description": "Vaše potvrzené vstupenky na nadcházející události.",
    "tickets.upcomingBookings": "Nadcházející události s vašimi vstupenkami",
    "tickets.searchBookings": "Hledat ve vstupenkách",
    "tickets.noMatchingBookings": "Nebyly nalezeny žádné vstupenky.",
    "tickets.allBookings": "Všechny moje vstupenky",
    "tickets.registered": "Máte vstupenku",
    "tickets.register": "Získat vstupenku",
    "tickets.unavailable": "Vstupenky nejsou dostupné",
    "tickets.registration": "Vstupenky na událost",
    "tickets.places": "Počet vstupenek",
    "tickets.quantity": "Počet vstupenek: {count}",
    "tickets.immediate": "Vstupenky jsou potvrzené ihned, bez čekání na schválení.",
    "tickets.saving": "Potvrzování…",
    "tickets.confirm": "Potvrdit vstupenky",
    "tickets.success": "Vaše vstupenky jsou potvrzené.",
    "tickets.error": "Vstupenky se nepodařilo potvrdit. Zkontrolujte jejich dostupnost a zadané údaje.",
    "events.participantName": "Jméno účastníka",
    "events.participantDescription": "Přihlášení platí pro jednu konkrétní osobu.",
    "events.mine": "Moje přihlášení",
    "events.description": "Vaše potvrzená přihlášení na nadcházející události.",
    "events.upcomingBookings": "Nadcházející události, na které jste přihlášeni",
    "events.searchBookings": "Hledat v přihlášeních",
    "events.noMatchingBookings": "Nebyla nalezena žádná přihlášení.",
    "events.allBookings": "Všechna moje přihlášení",
    "tickets.buyerName": "Jméno kupujícího",
    "tickets.buyerDescription": "Vyplňte kontaktní údaje kupujícího a počet vstupenek. Jména návštěvníků nejsou potřeba.",
    "tickets.registerMore": "Získat další vstupenky"
  },
  "en": {
    "events.backToEvents": "Events",
    "events.registrationIntro": "Check your selected date and fill in your contact details.",
    "tickets.registrationIntro": "Check your selected date, choose the number of places and enter the buyer’s details.",
    "events.summary": "Selected event",
    "events.date": "Date and time",
    "events.location": "Location",
    "events.organizer": "Organizer",
    "events.occupancy": "Occupancy",
    "events.contactHeading": "Contact details",
    "events.unavailableTitle": "Event unavailable",
    "events.unavailableDescription": "This event or date is no longer available in the portal. Please choose another event.",
    "events.cancelled": "This date was cancelled",
    "events.closedDescription": "Choose another date from the events overview.",
    "events.signInHint": "Sign in to your account to register for this event.",
    "events.accessHint": "You cannot register for this event at the moment.",
    "events.addTicket": "Add a place",
    "events.removeTicket": "Remove a place",
    "events.title": "Events",
    "events.unlimited": "Unlimited capacity",
    "events.capacity": "Occupancy: {occupied}/{capacity}",
    "events.registered": "You are registered",
    "events.started": "Already started",
    "events.full": "Full",
    "events.register": "Register for event",
    "events.noAccountRequired": "No account or sign-in required.",
    "events.login": "Sign in to the portal",
    "events.unavailable": "Registration unavailable",
    "events.registration": "Event registration",
    "events.name": "Name",
    "events.email": "Email",
    "events.phone": "Phone (optional)",
    "events.places": "Number of places",
    "events.immediate": "Your registration is confirmed immediately, without approval.",
    "events.cancel": "Back",
    "events.saving": "Registering…",
    "events.confirm": "Confirm registration",
    "events.success": "Your registration is confirmed.",
    "events.error": "Registration failed. Check available places and your contact details.",
    "events.rateLimit": "Too many attempts. Please try again shortly.",
    "events.andTickets": "Events and tickets",
    "registrations.title": "My bookings and tickets",
    "registrations.description": "Your upcoming bookings and confirmed tickets.",
    "registrations.upcomingBookings": "Upcoming bookings and tickets",
    "registrations.searchBookings": "Search bookings and tickets",
    "registrations.noMatchingBookings": "No bookings or tickets found.",
    "registrations.allBookings": "All bookings and tickets",
    "schedule.emptyTitle": "No upcoming dates yet",
    "schedule.emptyDescription": "Your bookings, events and tickets will appear here.",
    "schedule.status.confirmed": "Confirmed",
    "schedule.status.completed": "Completed",
    "schedule.status.pending": "Awaiting confirmation",
    "schedule.status.cancelled": "Cancelled",
    "schedule.status.no_show": "No-show",
    "schedule.status.unknown": "Status unavailable",
    "tickets.title": "Tickets",
    "tickets.mine": "My tickets",
    "tickets.description": "Your confirmed tickets for upcoming events.",
    "tickets.upcomingBookings": "Upcoming events with your tickets",
    "tickets.searchBookings": "Search tickets",
    "tickets.noMatchingBookings": "No tickets found.",
    "tickets.allBookings": "All my tickets",
    "tickets.registered": "You have a ticket",
    "tickets.register": "Get a ticket",
    "tickets.unavailable": "Tickets unavailable",
    "tickets.registration": "Event tickets",
    "tickets.places": "Number of tickets",
    "tickets.quantity": "Number of tickets: {count}",
    "tickets.immediate": "Tickets are confirmed immediately, without approval.",
    "tickets.saving": "Confirming…",
    "tickets.confirm": "Confirm tickets",
    "tickets.success": "Your tickets are confirmed.",
    "tickets.error": "Unable to confirm tickets. Check availability and your contact details.",
    "events.participantName": "Participant name",
    "events.participantDescription": "This registration is for one specific person.",
    "events.mine": "My registrations",
    "events.description": "Your confirmed registrations for upcoming events.",
    "events.upcomingBookings": "Upcoming events you are registered for",
    "events.searchBookings": "Search registrations",
    "events.noMatchingBookings": "No registrations found.",
    "events.allBookings": "All my registrations",
    "tickets.buyerName": "Buyer name",
    "tickets.buyerDescription": "Enter the buyer’s contact details and the number of tickets. Attendee names are not required.",
    "tickets.registerMore": "Get more tickets"
  }
} as const;
